import { useScrollTrigger } from '@abyss/web/hooks/useScrollTrigger';

const PageScrollService = () => {
  const { scrollIntoView, targetRef, scrollableRef } = useScrollTrigger({
    offset: 60,
  });

  const ScrollToTop = async () => {
    await scrollIntoView({
        alignment: 'start',
    });
  }
  return { pageTop: targetRef, ScrollToTop };
};

export { PageScrollService }